import { getFrontSetting } from "@/api/user"
import store from "./index"

export function setUnreadMessageCount(count) {
  return store.dispatch("user/setUnreadMessageCount", count)
}

export function setLocation(location) {
  return store.dispatch("user/setLocation", location)
}

export function initOssClient() {
  return store.dispatch("app/initOssClient")
}

export function getProjectPermission() {
  return store.dispatch("app/getProjectPermission")
}

export async function refreshTheme() {
  let setting = await getFrontSetting("UI")
  if (setting?.theme?._) {
    await store.dispatch("user/setTheme", setting.theme._)
  }
}
